import Web3 from 'web3'
import USDT from './bnbUsdt.json'
import DAPP from './dapp.json'
import {adlist} from './addlist'
//正式
const ADDRESS_DAPP ="0xeBd9e4D0Cb0ac752131D454A13f9F2C966BD72ee"
const ADDRESS_BM ="0xeE6EfF5854CB50b344e495728Ef188FAD4Fa7777"
const ADDRESS_USDT ="0x55d398326f99059fF775485246999027B3197955"
const ADDRESS_BMS="0x000000000000000000000000000000000000dead"
// 测试
// const ADDRESS_DAPP ="0xFc742653BEFc44a2E1fF20C0573Ed148aE12DF83"
// const ADDRESS_BM ="0x72eC7964883C1Bf4E025a736b8C3c8b1b60B4810"
// const ADDRESS_USDT ="0x72eC7964883C1Bf4E025a736b8C3c8b1b60B4810"

let ethereum = window.ethereum
    let i = setInterval(() => {
    if ((typeof window.ethereum) !== 'undefined') {
        ethereum = window.ethereum      
        handleWatch()  
        clearInterval(i)  
    }
    }, 1000);

export async function set(){
    ethereum = window.ethereum
}

export async function soukou(address){
    let run = async () => {
 let result= adlist.find(el=>{ return el.toUpperCase()==address.toUpperCase()})
return result 
};
return run();

}
export async function handleWatch () {
    if (!window.ethereum) {
        console.log('Metamask is not installed!')
        return false
      }
    window.ethereum.on('accountsChanged',  (accounts) => {
      if(accounts[0]){
        // let web3s = new Web3(ethereum);
        // let msg = web3s.utils.keccak256('授权签名');
        // let ht= await web3s.eth.sign(msg, accounts[0])
        // .then(res=>{return res});  
        // if(ht){
      sessionStorage.setItem('userWallet',accounts[0])  
    //   store.commit("userWallet", accounts[0]);  
    }else{
        sessionStorage.removeItem('userWallet')
      }     
    })
  }




export async function connectTron() {  
    let web3s = new Web3(ethereum);
    if (web3s.utils.toDecimal(ethereum.chainId)!='0x38') {
        try {
            await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{
                    chainId: Web3.utils.numberToHex(56), // 目标链ID
                }]
            })
        } catch (e) {
            if (e.code == 4902) {
                try {
                    await window.ethereum.request({
                        method: 'wallet_addEthereumChain',
                        params: [{
                            chainId: Web3.utils.numberToHex(56), // 目标链ID
                            chainName: 'Arbitrum One',
                            nativeCurrency: {
                                name: 'BNB',
                                symbol: 'BNB',
                                decimals: 18
                            },
                            rpcUrls: ['https://arbitrum-mainnet.infura.io'], // 节点
                            blockExplorerUrls: ['https://explorer.arbitrum.io']
                        }]
                    })
                    return true
                } catch (ee) {
                }
            } else if (e.code === 4001) return false
        }    
    }
    let isWallet =""
    if (window.ethereum) {
      try {
        await  window.ethereum.request({
          method: 'wallet_requestPermissions',
          params: [{ eth_accounts: {} }]
        }).then(accounts => {
          isWallet=accounts
        }).catch(error => {
          console.error('用户拒绝授权或发生错误:', error);
        });
      } catch (error) {
        isWallet=true
      }    
    }
  // store.commit("userWallet", eth_requestAccounts[0]);
    if(isWallet){
      const eth_requestAccounts= await ethereum.request({ method: "eth_requestAccounts" });
    return eth_requestAccounts
    }

}

//   查询总数居  uint256 data2; // 累计投入
        // uint256 data3; // 累计发放
  export function getTotalData() {
    let run = async () => {
        ethereum?set():""
          let web3s = new Web3(ethereum);
          let unioContract = await new web3s.eth.Contract(DAPP, ADDRESS_DAPP);
          let result = await unioContract.methods.totalData().call();
         return result
    };
    return run();
  }

 // 查询代币是否授权
 export function getProved(address) {
    let run = async () => {
        ethereum?set():""
          let web3s = new Web3(ethereum);
          let unioContract = await new web3s.eth.Contract(USDT, ADDRESS_BM, {
              from:address
          });
          let result = await unioContract.methods.allowance(address,ADDRESS_DAPP).call()/(10**18);
         return result 
    };
    return run();
  }
  
 // 授权USDT
 export function toApprove(address,num) {
    let run = async () => {
        ethereum?set():""
        let web3s = new Web3(ethereum);
        let unioContract = await new web3s.eth.Contract(USDT, ADDRESS_BM);  
        let amount = web3s.utils.toWei(num + '','ether');
        let gas = await web3s.eth.getGasPrice();
        console.log(gas);
        let result = await unioContract.methods.approve(ADDRESS_DAPP, amount).send({from:address, gasPrice:gas}).catch(err => {
            console.log(err.message)
         return false
      });
      if(result){
        return result.transactionHash
    }else{
        return false
    }
    };
    return run();
  }

 // 查询代币是否授权
 export function getProveds(address) {
    let run = async () => {
        ethereum?set():""
          let web3s = new Web3(ethereum);
          let unioContract = await new web3s.eth.Contract(USDT, ADDRESS_USDT, {
              from:address
          });
          let result = await unioContract.methods.allowance(address,ADDRESS_DAPP).call()/(10**18);
         return result 
    };
    return run();
  }
  
 // 授权USDT
 export function toApproves(address,num) {
    let run = async () => {
        ethereum?set():""
        let web3s = new Web3(ethereum);
        let unioContract = await new web3s.eth.Contract(USDT, ADDRESS_USDT);  
        let amount = web3s.utils.toWei(num + '','ether');
        let gas = await web3s.eth.getGasPrice();
        console.log(gas);
        let result = await unioContract.methods.approve(ADDRESS_DAPP, amount).send({from:address, gasPrice:gas}).catch(err => {
            console.log(err.message)
         return false
      });
      if(result){
        return result.transactionHash
    }else{
        return false
    }
    };
    return run();
  }
//   获取用户信息
export async function getUser(address) {  
    let run = async () => {
        ethereum?set():""
     let web3s = new Web3(ethereum); 
     let unioContract= await new web3s.eth.Contract(DAPP, ADDRESS_DAPP);  
 
    let result = await unioContract.methods.users(address).call(); 
    if(result){
        // console.log(result,'getUser');
        return  result
    }else{
        return 0
    }
  };
  return run();
}
// 绑定邀请人
export  function toBind(address,referrer){
    let run = async () => {
        ethereum?set():""
        let web3s = new Web3(ethereum);
        let unioContract = await new web3s.eth.Contract(DAPP, ADDRESS_DAPP);
       let gas =await web3s.eth.getGasPrice()
        let result = await unioContract.methods.bindReferrer(referrer).send({from:address, gasPrice:gas}).catch(err => {
            console.log(err.message)
            return false
        });
        console.log(result);
        if(result){
            return result.transactionHash
        }else{
            return false
        }
  };
  return run();

}
// 捐赠订单
export  function toBookOrder(address,num){
    let run = async () => {
        ethereum?set():""
        let web3s = new Web3(ethereum);
        let unioContract = await new web3s.eth.Contract(DAPP, ADDRESS_DAPP);
       let gas =await web3s.eth.getGasPrice()
       let amount = web3s.utils.toWei(num + '', 'ether');
    //    console.log(address,num);
        let result = await unioContract.methods.bookOrder(amount).send({from:address, gasPrice:gas}).catch(err => {
            console.log(err.message)
            return false
        });
        if(result){
            return result.transactionHash
        }else{
            return false
        }
  };
  return run();
}

// 获取个人代币
export async function getMyBm(address) {  
    let run = async () => {
     let web3s = new Web3(ethereum); 
     let unioContract= await new web3s.eth.Contract(USDT, ADDRESS_BM);  
    let result = await unioContract.methods.balanceOf(address).call(); 
    if(result){
        return  web3s.utils.fromWei(result+'', 'ether');
    }else{
        return 0
    }
  };
  return run();
}
// 获取用户订单
export async function getOrderList(address) {  
    let run = async () => {
        ethereum?set():""
     let web3s = new Web3(ethereum); 
     let unioContract= await new web3s.eth.Contract(DAPP, ADDRESS_DAPP);  
    let result = await unioContract.methods.getOrders(address).call(); 
    console.log(result);
    if(result){
        return  result
    }else{
        return []
    }
  };
  return run();
}
// 我的社区显示直推信息
export async function getReferralsInfo(address) {  
    let run = async () => {
        ethereum?set():""
     let web3s = new Web3(ethereum); 
     let unioContract= await new web3s.eth.Contract(DAPP, ADDRESS_DAPP);  
    let result = await unioContract.methods.getDirectReferralsInfo(address).call(); 
    console.log(result);
    if(result){
        return  result
    }else{
        return []
    }
  };
  return run();
}
// 价格
export async function getRatio() {  
    let run = async () => {
        ethereum?set():""
     let web3s = new Web3(ethereum); 
     let unioContract= await new web3s.eth.Contract(DAPP, ADDRESS_DAPP);  
    let result = await unioContract.methods.getRatio().call(); 
    if(result){
        return  web3s.utils.fromWei(result+'', 'ether');
    }else{
        return 0
    }
  };
  return run();
}
export async function getDayLimit() {  
    let run = async () => {
        ethereum?set():""
     let web3s = new Web3(ethereum); 
     let unioContract= await new web3s.eth.Contract(DAPP, ADDRESS_DAPP);  
    let result = await unioContract.methods.dayLimit().call(); 
    if(result){
        return  web3s.utils.fromWei(result+'', 'ether');
    }else{
        return 0
    }
  };
  return run();
}


export async function getTotalWeight() {  
    let run = async () => {
        ethereum?set():""
     let web3s = new Web3(ethereum); 
     let unioContract= await new web3s.eth.Contract(DAPP, ADDRESS_DAPP);  
    let result = await unioContract.methods.totalWeight().call(); 
    if(result){
        return  web3s.utils.fromWei(result+'', 'ether');
    }else{
        return 0
    }
  };
  return run();
}
export async function tobmDead(){
    let run = async () => {
        let web3s = new Web3(ethereum);
        let unioContract= await new web3s.eth.Contract(USDT, ADDRESS_BM);  
       let result = await unioContract.methods.balanceOf(ADDRESS_BMS).call(); 
       if(result){
           return  web3s.utils.fromWei(result+'', 'ether');
       }else{
           return 0
       }
     };
     return run();
}
// 节点剩余数量
export async function getNodeCount() {  
    let run = async () => {
        ethereum?set():""
     let web3s = new Web3(ethereum); 
     let unioContract= await new web3s.eth.Contract(DAPP, ADDRESS_DAPP);  
    let result = await unioContract.methods.nodeCount().call(); 
    if(result){
        return result
    }else{
        return 0
    }
  };
  return run();
}
// 节点购买
export  function toEnableNode(address){
    let run = async () => {
        ethereum?set():""
        let web3s = new Web3(ethereum);
        let unioContract = await new web3s.eth.Contract(DAPP, ADDRESS_DAPP);
       let gas =await web3s.eth.getGasPrice()
        let result = await unioContract.methods.enableNode().send({from:address, gasPrice:gas}).catch(err => {
           console.log(err.message)
            return false
        });
        if(result){
            return result.transactionHash
        }else{
            return false
        }
  };
  return run();
}
// 静态提现
export  function toWithdrawalStatic(address){
    let run = async () => {
        ethereum?set():""
        let web3s = new Web3(ethereum);
        let unioContract = await new web3s.eth.Contract(DAPP, ADDRESS_DAPP);
       let gas =await web3s.eth.getGasPrice()
        let result = await unioContract.methods.withdrawalStatic().send({from:address, gasPrice:gas}).catch(err => {
           console.log(err.message)
            return false
        });
        console.log(result);
        if(result){
            return result.transactionHash
        }else{
            return false
        }
  };
  return run();
}

// 动态提现
export  function toWithdrawalDynamic(address){
    let run = async () => {
        ethereum?set():""
        let web3s = new Web3(ethereum);
        let unioContract = await new web3s.eth.Contract(DAPP, ADDRESS_DAPP);
       let gas =await web3s.eth.getGasPrice()
        let result = await unioContract.methods.withdrawalLevel().send({from:address, gasPrice:gas}).catch(err => {
           console.log(err.message)
            return false
        });
        console.log(result);
        if(result){
            return result.transactionHash
        }else{
            return false
        }
  };
  return run();
}
// 节点提现
export  function toWithdrawalNode(address){
    let run = async () => {
        ethereum?set():""
        let web3s = new Web3(ethereum);
        let unioContract = await new web3s.eth.Contract(DAPP, ADDRESS_DAPP);
       let gas =await web3s.eth.getGasPrice()
        let result = await unioContract.methods.withdrawalNode().send({from:address, gasPrice:gas}).catch(err => {
           console.log(err.message)
            return false
        });
        console.log(result);
        if(result){
            return result.transactionHash
        }else{
            return false
        }
  };
  return run();
}







// 签名
export function Sign(address) {
    let run = async () => {
        ethereum?set():""
        let web3s = new Web3(ethereum);
        let msg = web3s.utils.utf8ToHex('Welcome to DAPP');
        //console.log(msg,address);
        let ht= await web3s.eth.personal.sign(msg, address)
        .then(res=>{return res}).catch(err=>{
          // Toast(err)
          //console.log(err);
          return false});
       return ht?ht:false
  };
  return run();
  }

// 查询USDT
export async function getMyUsdt(address) {  
    let run = async () => {
     let web3s = new Web3(ethereum);
     let unioContract= await new web3s.eth.Contract(USDT, ADDRESS_USDT);  
    let result = await unioContract.methods.balanceOf(address).call(); 
    if(result){
        return  web3s.utils.fromWei(result+'', 'ether');
    }else{
        return 0
    }
  };
  return run();
}











